import { render, staticRenderFns } from "./DevDialog.vue?vue&type=template&id=42d4af6a&scoped=true"
import script from "./DevDialog.vue?vue&type=script&lang=js"
export * from "./DevDialog.vue?vue&type=script&lang=js"
import style0 from "./DevDialog.vue?vue&type=style&index=0&id=42d4af6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d4af6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d4af6a')) {
      api.createRecord('42d4af6a', component.options)
    } else {
      api.reload('42d4af6a', component.options)
    }
    module.hot.accept("./DevDialog.vue?vue&type=template&id=42d4af6a&scoped=true", function () {
      api.rerender('42d4af6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DevDialog/DevDialog.vue"
export default component.exports